import type { CoachingCoachCoacheesCoacheeModel } from '@efdigital/ll-xceed-v2/routes/coaching/coach/coachees/coachee';
import Route from '@ember/routing/route';

export default class CoachingCoachCoacheesCoacheeCanceledRoute extends Route<CoachingCoachCoacheesCoacheeModel> {
  model(): CoachingCoachCoacheesCoacheeModel {
    return this.modelFor(
      'coaching.coach.coachees.coachee'
    ) as CoachingCoachCoacheesCoacheeModel;
  }
}
